import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({
        method: 'SetEntryFlashGameFlag',
        args: {
            game_id: payload?.game_id,
            entry_id: payload?.entry_id,
            flag: payload?.flag,
        },
    });

    return result;
};
